/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Waiting_Room_Body_YouInputs */



/**
* | output |
* | --- |
* | "You still have to let the notetaker in. It is called \"Wundo\" in the list of people waiting." |
*
* @param {Meeting_Notetaker_Issue_Waiting_Room_Body_YouInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_waiting_room_body_you = /** @type {((inputs?: Meeting_Notetaker_Issue_Waiting_Room_Body_YouInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Waiting_Room_Body_YouInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Jij moet de notetaker nog binnenlaten. Hij heet \"Wundo\" in de lijst met wachtenden.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous devez encore laisser entrer le notetaker. Il s'appelle \"Wundo\" dans la liste d'attente.")
	return /** @type {LocalizedString} */ ("You still have to let the notetaker in. It is called \"Wundo\" in the list of people waiting.")
});